import Axios from 'axios';

const TOKEN_VALID_RESOURCE = '/token_valid';
const PW_RESET_RESOURCE = '/change_password_with_token';
const PW_USR_SET_RESOURCE = '/set_username_and_password_with_token';
const ACCOUNT_GET_RESOURCE = '/current_user';
const CHNAGE_MAIL_RESOURCE = '/change_email';
const VERIFY_EMAIL_RESOURCE = '/verify_email';
const CHANGE_PASSWORD_RESOURCE = '/change_password';
const CHANGE_WIFI_PASSWORD_RESOURCE = '/change_wifi_password';
const RESET_PASSWORD_RESOURCE = '/reset_password';
const CARDS_RESOURCE = '/account/cards';
const CARD_DELETE_RESOURCE = '/account/cards/delete';

export default {
    check_token_validity(token) {
        return Axios.get(TOKEN_VALID_RESOURCE + '?token=' + token)
    },
    reset_password_with_token(token, new_password) {
        return Axios.post(PW_RESET_RESOURCE, {token: token, new_password: new_password})
    },
    set_username_and_password_with_token(token, new_email, new_username, new_password) {
        return Axios.post(PW_USR_SET_RESOURCE, {
            token: token,
            new_email: new_email,
            new_username: new_username,
            new_password: new_password
        })
    },
    get_current_user() {
        return Axios.get(ACCOUNT_GET_RESOURCE)
    },
    change_email(new_email) {
        return Axios.post(CHNAGE_MAIL_RESOURCE, {new_email: new_email})
    },
    verify_email(token) {
        return Axios.post(VERIFY_EMAIL_RESOURCE, {token: token})
    },
    change_password(old_password, new_password) {
        return Axios.post(CHANGE_PASSWORD_RESOURCE, {old_password: old_password, new_password: new_password})
    },
    change_wifi_password(new_password) {
        return Axios.post(CHANGE_WIFI_PASSWORD_RESOURCE, {new_password: new_password})
    },
    reset_password(email) {
        return Axios.post(RESET_PASSWORD_RESOURCE, {email: email})
    },
    getCards() {
        return Axios.get(CARDS_RESOURCE)
    },
    deleteCard(card) {
        return Axios.post(CARD_DELETE_RESOURCE, {card: card})
    }
};
